import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { PermitSubLocation, IPermitSubLocation } from "@/model/PermitSubLocation";

export interface IPermitLocation {
    description:string;
    subLocations: Array<IPermitSubLocation>;
}

export class PermitLocation implements IPermitLocation {
    constructor(data?: any) {
        if (data) this.update(data);
    }

    update(data: any): PermitLocation {
        mapData(data, {
            root: () => this,
            subLocations: (data: any) => new PermitSubLocation(data)
        });
        return this;
    }

    description:string = "";
    subLocations: Array<PermitSubLocation> = [];

    // just for UI binding - not part of server model
    newSubLocationText: string = "";
}
